import { isValid } from 'date-fns/isValid';
import { parseISO } from 'date-fns/parseISO';

import { logger } from '@/lib/logger';

export const pluralize = (
  count: number,
  singular: string,
  plural?: string
): string => {
  return count === 1 ? singular : plural || `${singular}s`;
};

let reportedStringDate = false;

/** Normalizes a Date or ISO string to an ISO string, returning null for invalid input */
export function toISODateString(
  value: Date | string | null | undefined
): string | null {
  if (!value) return null;

  if (typeof value === 'string') {
    if (!reportedStringDate) {
      reportedStringDate = true;

      logger.warn('Date field received string instead of Date object', {
        source: 'date-utils',
        value,
      });
    }

    const parsed = parseISO(value);

    if (!isValid(parsed)) {
      logger.warn('Date string failed to parse', {
        source: 'date-utils',
        value,
      });

      return null;
    }

    return parsed.toISOString();
  }

  return isValid(value) ? value.toISOString() : null;
}
